// extracted by mini-css-extract-plugin
module.exports = {"squareLogoImage":"OverlayLogoImage_squareLogoImage__Ca8Jk","rectangleLogoimage":"OverlayLogoImage_rectangleLogoimage__fK2cG"};